import { useParams } from 'react-router-dom';
import { App, ConfigProvider } from 'antd'
import useStyleStore from '@/stores/StyleStore'
import EmailDetailInline from './Conversations/Online/Components/EmailDetailInline';


/**
 * 独立窗口查看邮件
 *
 * - 从销售平台进入: 自动复制 storage, 可读取loginUser
 *
 * ! 无状态管理
 */
const EmailDetailWindow = () => {
  const pageParam = useParams();
  // console.log(pageParam)

  // const [mobile] = useStyleStore((state) => [state.mobile])

  return (
    <>
      <ConfigProvider theme={{ token: { colorPrimary: '#6366f1' } }}>
        <EmailDetailInline mailID={pageParam.mailid} variant={'full'} />
      </ConfigProvider>
    </>
  )
}
export default EmailDetailWindow
